export default "__VITE_ASSET__C4Wl9Mdi__"